import { z } from 'zod';

/** Khóa BIGSERIAL trong JSON luôn là chuỗi, không dùng number để tránh mất chính xác. */
export const IdString = z.string().regex(/^[1-9]\d{0,18}$/, 'id phải là số nguyên dương dạng chuỗi');
export type IdString = z.infer<typeof IdString>;

/** Tiền VND dạng chuỗi số nguyên, ví dụ "-12500". */
export const MoneyString = z.string().regex(/^-?\d{1,18}$/, 'tiền phải là số nguyên VND dạng chuỗi');

export const MonthPeriod = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'kỳ tháng dạng YYYY-MM');
export const QuarterPeriod = z.string().regex(/^\d{4}-Q[1-4]$/, 'kỳ quý dạng YYYY-Qn');
export const Period = z.union([MonthPeriod, QuarterPeriod]);
export type Period = z.infer<typeof Period>;

export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'ngày dạng YYYY-MM-DD');

export const Platform = z.enum(['shopee', 'tiktok']);
export type Platform = z.infer<typeof Platform>;

export const TaxCode = z
  .string()
  .regex(/^(\d{10}(-\d{3})?|\d{12})$/, 'MST gồm 10 số, 10-3 số hoặc 12 số');

export const ErrorCode = z.enum([
  'VALIDATION_FAILED',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'PERIOD_CLOSED',
  'REAUTH_REQUIRED',
  'RATE_LIMITED',
  'UPSTREAM_UNAVAILABLE',
  'INTERNAL',
]);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ERROR_HTTP_STATUS: Record<ErrorCode, number> = {
  VALIDATION_FAILED: 400,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PERIOD_CLOSED: 409,
  REAUTH_REQUIRED: 409,
  RATE_LIMITED: 429,
  UPSTREAM_UNAVAILABLE: 503,
  INTERNAL: 500,
};

export const ApiErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
  correlation_id: z.string(),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;

/** Phong bì thành công: { data, meta? }. */
export const envelope = <T extends z.ZodType>(data: T) =>
  z.object({
    data,
    meta: z.object({ next_cursor: z.string().nullable().optional() }).optional(),
  });

export const CursorQuery = z.object({
  cursor: z.string().max(512).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});

/** Header chọn công ty (tenant) cho mỗi request nghiệp vụ. */
export const TENANT_HEADER = 'x-tenant-id';
export const CORRELATION_HEADER = 'x-correlation-id';
